export function setItem(name: string, value: any, type = 'ls') {
    const storage = type === 'ls' ? localStorage : sessionStorage;
    const str = name;
    if (typeof value === 'string') {
        storage.setItem(str, value);
    } else {
        storage.setItem(str, JSON.stringify(value));
    }
}
export function getItem(name: string, type = 'ls') {
    const storage = type === 'ls' ? localStorage : sessionStorage;
    const str = name;
    if (!storage.getItem(str)) {
        return '';
    } else {
        const value = storage.getItem(str) || '';
        if (isJSON(value)) {
            return JSON.parse((storage.getItem(str) as string) || '{}');
        } else {
            return value;
        }
    }
}
export function removeItem(name: string, type = 'ls') {
    const storage = type === 'ls' ? localStorage : sessionStorage;
    const str = name;
    storage.removeItem(str);
}
export function clear() {
    localStorage.clear();
    sessionStorage.clear();
}
function isJSON(str: string) {
    if (typeof str == 'string') {
        try {
            const obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }
}
